import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/layout/Navbar";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Rewards from "@/pages/Rewards";
import Profile from "@/pages/Profile";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminRewards from "@/pages/admin/AdminRewards";
import AdminClients from "@/pages/admin/AdminClients";
import AdminMessages from "@/pages/admin/AdminMessages";
import Contact from "@/pages/Contact";

function HomeRoute() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-[60vh]"/>;
  if (user && user.role === "admin") return <Navigate to="/admin" replace/>;
  return <Landing/>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar/>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#0a0e0b", border: "1px solid rgba(253,251,247,0.1)", color: "#fdfbf7" } }}/>
          <Routes>
            <Route path="/" element={<HomeRoute/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/register" element={<Register/>} />

            <Route path="/produits" element={<Products/>}/>
            <Route path="/contact" element={<Contact/>}/>

            <Route path="/dashboard" element={<ProtectedRoute role="client"><Dashboard/></ProtectedRoute>}/>
            <Route path="/recompenses" element={<ProtectedRoute role="client"><Rewards/></ProtectedRoute>}/>
            <Route path="/profil" element={<ProtectedRoute role="client"><Profile/></ProtectedRoute>}/>

            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard/></ProtectedRoute>}/>
            <Route path="/admin/produits" element={<ProtectedRoute role="admin"><AdminProducts/></ProtectedRoute>}/>
            <Route path="/admin/recompenses" element={<ProtectedRoute role="admin"><AdminRewards/></ProtectedRoute>}/>
            <Route path="/admin/clients" element={<ProtectedRoute role="admin"><AdminClients/></ProtectedRoute>}/>
            <Route path="/admin/messages" element={<ProtectedRoute role="admin"><AdminMessages/></ProtectedRoute>}/>

            <Route path="*" element={<Navigate to="/" replace/>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
